// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/e-surance-invoice-address-schema',
  type: 'object',
  required: ['correspondenceLanguageIso2'],
  properties: {
    correspondenceLanguageIso2: {
      type: 'string',
      minLength: 1,
    },
    isInvoiceAddressNotMemberAddress: {
      type: 'boolean',
    },
    isTrusteeAddress: {
      type: 'boolean',
      nullable: true,
    },
    isCompany: {
      type: 'boolean',
      nullable: true,
    },
    companyName: {
      type: 'string',
      nullable: true,
    },
    salutationKey: {
      type: 'integer',
      nullable: true,
    },
    salutationName: {
      type: 'string',
      nullable: true,
    },
    firstName: {
      type: 'string',
      nullable: true,
    },
    lastName: {
      type: 'string',
      nullable: true,
    },
    street: {
      type: 'string',
      nullable: true,
    },
    houseNumber: {
      type: 'string',
      nullable: true,
    },
    zipCode: {
      type: 'string',
      nullable: true,
    },
    city: {
      type: 'string',
      nullable: true,
    },
    email: {
      type: 'string',
      nullable: true,
    },
  },
} as IJSONSchema;

export default schema;
